export default [
	{
		path: "/test",
		component: () => import("@/views/test/Test"),
		meta: { layout: "Blank", menu: "", title: "Test" }
    },
];